import { useQuery } from '@apollo/client';

import getAllEqpDataQuery from 'bundles/directory-graphql/api/GetAllEqpData.graphql';
import type { SeoGetAllEqpDataV1QueryQuery } from 'bundles/directory-graphql/api/__generated__/GetAllEqpData';

type AllEQPData = {
  allEqpData: Array<{ title: string; link: string; localeCode?: string }>;
};

const useGetAllEqpData = (): AllEQPData => {
  const { data } = useQuery<SeoGetAllEqpDataV1QueryQuery, {}>(getAllEqpDataQuery, {
    context: {
      clientName: 'gatewayGql',
    },
  });

  const allSeoEqpData = data?.Seo?.seoGetAllEqpDataV1Query || [];

  return {
    allEqpData: allSeoEqpData.map(({ titleTag, url, locale }) => ({
      title: titleTag,
      link: url,
      localeCode: locale || undefined,
    })),
  };
};

export default useGetAllEqpData;
